import AdvancementIcon from '../../PulseCheck/img/advancement.svg';
import EngagementIcon from '../../PulseCheck/img/engagement.svg';
import HappinessIcon from '../../PulseCheck/img/happiness.svg';
import RelationshipsIcon from '../../PulseCheck/img/relationships.svg';
import StrengthIcon from '../../PulseCheck/img/strength.svg';
import TruthIcon from '../../PulseCheck/img/truth.svg';

export enum PulseCheckCategory {
  Happiness,
  Engagement,
  Advancement,
  Relationships,
  Truth,
  Strength,
}

export const PULSE_CHECK_CATEGORY_ICON_MAP = {
  [PulseCheckCategory.Happiness]: HappinessIcon,
  [PulseCheckCategory.Engagement]: EngagementIcon,
  [PulseCheckCategory.Advancement]: AdvancementIcon,
  [PulseCheckCategory.Relationships]: RelationshipsIcon,
  [PulseCheckCategory.Truth]: TruthIcon,
  [PulseCheckCategory.Strength]: StrengthIcon,
};
